import { render, staticRenderFns } from "./TitleText.vue?vue&type=template&id=124e829f&scoped=true"
import script from "./TitleText.vue?vue&type=script&lang=js"
export * from "./TitleText.vue?vue&type=script&lang=js"
import style0 from "./TitleText.vue?vue&type=style&index=0&id=124e829f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e829f",
  null
  
)

export default component.exports